export default "__VITE_ASSET__BQdd7Yi7__"